import Vue from 'vue';
import Vuex from 'vuex';

import atom from '@tencent/vft-atom';
import env from '@tencent/vft-common/env';
import login from '@tencent/wetv-common/login';

import { getUserPhone, isFirst } from 'src/service/vipService';
import { testAlert } from 'src/util/index';

Vue.use(Vuex);

const defaultAvatar = 'https://vip.image.video.qpic.cn/vupload/20230529/743b7e1685351520890.png';

export default new Vuex.Store({
  state: {
    is_login: false,
    nickname: '',
    avatar: defaultAvatar,
    phone: '',
    area_code: '',
    is_vip: false,
    vip_expire_date: '',
    is_first: true,
    redeem_succ: false,
    redeem_error: '',
    redeem_flag: 0,
    reset_flag: 0,
    app_info: null,
  },
  getters: {
    isAmerican({ app_info: appInfo }) {
      return appInfo && appInfo.appid ? +appInfo.appid === 1200014 : false;
    },
    isIflix({ app_info: appInfo }) {
      return appInfo && appInfo.appid ? +appInfo.appid === 1200016 : false;
    },
    appid({ app_info: appInfo }) {
      const pkgNames = {
        // 全球版
        'com.tencent.qqlivei18n': 1200004,
        // 越南版
        'com.tencent.qqlivei18n.tw': 1200009,
        // 美国版
        'com.tencent.qqlivei18n.us': 1200014,
      };
      return appInfo?.appid || pkgNames[appInfo?.pkgName] || 1200004;
    },
  },
  mutations: {
    setState(state, payload) {
      state[payload.state] = payload.value;
    },
  },
  actions: {
    async getAppInfo({ commit }) {
      const appInfo = await atom.getAppInfo();
      commit('setState', {
        state: 'app_info',
        value: appInfo,
      });
    },
    async getUserInfo({ commit, dispatch }) {
      // 如果用户绑定了手机号，此接口会wetv环境下，会返回区号和手机号
      const res = await login.getUserInfo();
      if (!res) return;
      let { areacode: areaCode = '', phone = '' } = res || {};
      const headurl = res.headurl || res.headImgUrl || '';
      const needGetPhoneFromApi = !env.isWetv && (!areaCode || !phone);
      if (needGetPhoneFromApi) {
        // getUserPhone接口在wetv app内不可调用
        const phoneRes = (await getUserPhone() || {});
        areaCode = phoneRes.areacode || '';
        phone = phoneRes.phone || '';
      }
      dispatch('checkIsFirst');
      commit('setState', {
        state: 'is_login',
        value: true,
      });

      commit('setState', {
        state: 'nickname',
        value: res.nickname,
      });

      commit('setState', {
        state: 'phone',
        value: phone,
      });

      commit('setState', {
        state: 'area_code',
        value: areaCode,
      });

      if (headurl) {
        commit('setState', {
          state: 'avatar',
          value: headurl,
        });
      }
      const payVip = await login.getPayVip();
      if (!payVip) return;
      commit('setState', {
        state: 'is_vip',
        value: payVip.vip === 1,
      });

      if (payVip.vip !== 1) {
        return;
      }
      commit('setState', {
        state: 'vip_expire_date',
        value: payVip.endTime.substr(0, 10),
      });
    },
    async checkIsFirst({ commit }) {
      testAlert('call checkIsFirst', null);
      const res = await isFirst();
      testAlert('checkIsFirst res', res);
      commit('setState', {
        state: 'is_first',
        value: res,
      });
    },
    resetIsLogin({ commit }, status) {
      commit('setState', {
        state: 'is_login',
        value: status,
      });
    },
    clearUserInfo({ commit }) {
      commit('setState', {
        state: 'is_login',
        value: false,
      });
      commit('setState', {
        state: 'avatar',
        value: defaultAvatar,
      });
      commit('setState', {
        state: 'nickname',
        value: '',
      });
      commit('setState', {
        state: 'phone',
        value: '',
      });
      commit('setState', {
        state: 'is_vip',
        value: false,
      });

      commit('setState', {
        state: 'vip_expire_date',
        value: '',
      });
    },
  },
});
